import React from 'react';

// The knktr wordmark, as drawn in the Claude Design sign-in file (project
// 53fe2c35…, 2026-09-17). Shared by the sign-in screens (PR #81) and the
// idle Voice screen header, so the mark is drawn from one source.
export default function Wordmark({ className } = {}) {
  return (
    <svg className={className} viewBox="-70 -770 3022 840" role="img" aria-label="knktr">
      <g fill="#00C8B8" transform="scale(1,-1)">
        <path transform="translate(0,0)" d="M70 0V700H196V313H214L378 496H542L313 256L550 0H388L214 197H196V0Z" />
        <path transform="translate(549,0)" d="M70 0V496H194V431H212Q224 457 257.0 480.5Q290 504 357 504Q415 504 458.5 477.5Q502 451 526.0 404.5Q550 358 550 296V0H424V286Q424 342 396.5 370.0Q369 398 318 398Q260 398 228.0 359.5Q196 321 196 252V0Z" />
        <path transform="translate(1150,0)" d="M70 0V700H196V313H214L378 496H542L313 256L550 0H388L214 197H196V0Z" />
        <path transform="translate(1699,0)" d="M260 0Q211 0 180.5 30.5Q150 61 150 112V392H26V496H150V650H276V496H412V392H276V134Q276 104 304 104H400V0Z" />
        <path transform="translate(2140,0)" d="M70 0V496H194V440H212Q223 470 248.5 484.0Q274 498 308 498H368V386H306Q258 386 227.0 360.5Q196 335 196 282V0Z" />
      </g>
      <circle cx="2764" cy="-582" r="118" fill="#00C8B8" />
    </svg>
  );
}
